import {createContext,useState,useContext,useRef} from 'react';
import {Dialog,DialogTitle,DialogContent,DialogActions,Button} from '@mui/material';
import {useApplication} from './ApplicationContext';
const ConfirmContext=createContext();
export const useConfirm=()=>useContext(ConfirmContext);

export const ConfirmProvider=({children})=>{
    const {globalData}=useApplication();
    const application={globalData,getLocale:(key,options)=>globalData?.getLocale(key,options)};

    const[confirmState,setConfirmState]=useState({
        open:false,
        message:'',
        title:'',
    });
    const resolveRef=useRef(null);
    const resultRef=useRef(false);

    const confirm=({message,title})=>{
        return new Promise((resolve)=>{
            resolveRef.current=resolve;
            setConfirmState({open:true,message,title});
        });
    };

    const handleClose=()=>{
        resultRef.current=false;
        setConfirmState((prev)=>({ ...prev,open:false}));
    };

    const handleConfirm=()=>{
        resultRef.current=true;
        setConfirmState((prev)=>({ ...prev,open:false }));
    };

    const handleExited=()=>{//Resolve only once the dialog has fully unmounted, otherwise the caller can act (e.g. open another modal) while #root is still aria-hidden by this closing one
        if(resolveRef.current){
            resolveRef.current(resultRef.current);
            resolveRef.current=null;
        }
    };

    return (
        <ConfirmContext.Provider value={{confirm}}>
            {children}
            <Dialog open={confirmState.open} onClose={handleClose} disableRestoreFocus slotProps={{transition:{onExited:handleExited}}}>
                {confirmState.title&&<DialogTitle>{confirmState.title}</DialogTitle>}
                <DialogContent>
                    <p>{confirmState.message}</p>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="darkred">{globalData&&application.getLocale("ButtonCancel")}</Button>
                    <Button onClick={handleConfirm} color="primary">{globalData&&application.getLocale("ButtonConfirm")}</Button>
                </DialogActions>
            </Dialog>
        </ConfirmContext.Provider>
    );
};

export default ConfirmProvider;
